import { sessionManager } from 'vue-infra';
import { PRIVILEGES } from '@/const/privileges';
import { FEATURES } from '@/const/features';
import { APPS } from '../const/apps';

const hasConversationAssistPermission = () => {
  const conversationBuilderEnabled = sessionManager.getFeaturePropertyState(
    FEATURES.AUTOMATION_CONVERSATION_BULDER,
  );
  return (
    conversationBuilderEnabled
    && (sessionManager.hasPrivilege(PRIVILEGES.CB_VIEW_BOTS)
      || sessionManager.hasPrivilege(PRIVILEGES.CB_VIEW_KNOWLEDGE_BASE)
      // old roles - backwards compatibility
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_ADMIN)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_BOTS)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_CONTENT_USER)
      // LPA
      || sessionManager.isLPA())
  );
};

export const getAvailableApps = () => {
  const availableApps = {};

  function toggleApp(code, enabled) {
    if (enabled) {
      availableApps[code] = APPS[code];
    }
  }

  const conversationBuilderEnabled = sessionManager.getFeaturePropertyState(FEATURES.AUTOMATION_CONVERSATION_BULDER);
  const performanceOptimizerEnabled = sessionManager.isLPA() || sessionManager.getFeaturePropertyState(FEATURES.INTELLIGENCE_PERFORMANCE_PORTAL_ACCESS);
  const dataTransporterEnabled = sessionManager.isLPA() || sessionManager.getFeaturePropertyState(FEATURES.INTELLIGENCE_DATA_TRANSPORTER_ACCESS);

  toggleApp(
    'BOT_BUILDER',
    conversationBuilderEnabled
    && (sessionManager.hasPrivilege(PRIVILEGES.CB_VIEW_BOTS)
      // old roles - backwards compatibility
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_ADMIN)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_BOTS)
      // LPA
      || sessionManager.isLPA()),
  );

  toggleApp(
    'KNOWLEDGE_BASE',
    conversationBuilderEnabled
    && (sessionManager.hasPrivilege(PRIVILEGES.CB_VIEW_KNOWLEDGE_BASE)
      // old roles - backwards compatibility
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_ADMIN)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_BOTS)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_CONTENT_USER)
      // LPA
      || sessionManager.isLPA()),
  );

  const analyticsEnabled = conversationBuilderEnabled
    && (sessionManager.hasPrivilege(PRIVILEGES.CB_VIEW_ANALYTICS)
      // old roles - backwards compatibility
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_ADMIN)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_BOTS)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_CONTENT_USER)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_BUSINESS_USER)
      // LPA
      || sessionManager.isLPA());
  toggleApp('ANALYTICS', analyticsEnabled);

  toggleApp(
    'INTENT_MANAGER',
    conversationBuilderEnabled
    && (sessionManager.hasPrivilege(PRIVILEGES.CB_VIEW_DOMAIN)
      // old roles - backwards compatibility
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_ADMIN)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_BOTS)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_CONTENT_USER)
      // LPA
      || sessionManager.isLPA()),
  );

  toggleApp('CONVERSATION_ASSIST', hasConversationAssistPermission());

  toggleApp(
    'ORG_MGMT',
    conversationBuilderEnabled
    // credentials, admin and LPA only until there are new permissions
    && (sessionManager.hasPrivilege(PRIVILEGES.CB_CREATE_EDIT_CREDENTIALS)
      || sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_ADMIN)
      || sessionManager.isLPA()),
  );

  toggleApp(
    'SYS_ADMIN',
    conversationBuilderEnabled
    // old roles and LPA only until there are new permissions
    && (sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_OPERATIONS) || sessionManager.isLPA()),
  );

  toggleApp('BOT_PLATFORM', sessionManager.getFeaturePropertyState(FEATURES.AUTOMATION_BOT_CONNECTORS));

  toggleApp('PERFORMANCE_OPTIMIZER', performanceOptimizerEnabled);
  toggleApp('DATA_TRANSPORTER', dataTransporterEnabled);

  const mavenEnabled = sessionManager.hasPrivilege(PRIVILEGES.ADMIN_PRIVILEGE) || sessionManager.isLPA();
  toggleApp('MAVEN', mavenEnabled);
  toggleApp('AIWB', sessionManager.hasPrivilege(PRIVILEGES.ADMIN_PRIVILEGE) || sessionManager.isLPA());

  return availableApps;
};

export default hasConversationAssistPermission;
